/*
 * @Description:
 * @version:
 * @Author: 李云飞
 * @Date: 2023-07-11 16:32:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-05 14:36:05
 */

import { createRouter, createWebHashHistory } from 'vue-router';
import { staticRoutes } from './routes.js';
import { useUserStore } from '@/store/user.js';
import { useSystemStore } from '@/store/system.js';
import { MENU_TYPE_ENUM } from '@/constants/system';
import Layout from '@/layout/layout.vue';
import lodash from 'lodash';
import localStorageKeyConst from '@/constants/local-storage-key-const';
const { LOGIN_PAGE, HOME_PAGE } = localStorageKeyConst;

// 设置路由组件的name，用于keepAlive
function setComponentsName(list) {
  for (let i = 0; i < list.length; i++) {
    if (list[i].component && lodash.isFunction(list[i].component)) {
      list[i].component().then((val) => {
        val.default.name = list[i].name;
      });
    }
    if (!lodash.isEmpty(list[i].children)) {
      list[i].children = setComponentsName(list[i].children);
    }
  }
  return list;
}

const staticRouteList = setComponentsName(staticRoutes);

export const router = createRouter({
  history: createWebHashHistory(),
  routes: staticRouteList,
  strict: true
});

// 标记是否已添加动态路由
let dynamicRoutesAdded = false;

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore();
  const isAuthenticated = !!userStore.getToken;
  const menuList = userStore.getUserMenuList;
  try {
    // 情况1：目标是登录页
    if (to.name === LOGIN_PAGE) {
      // 已登录用户不应进登录页 → 跳首页
      if (isAuthenticated) {
        next({ name: HOME_PAGE });
        return;
      }
      // 未登录用户允许进入登录页
      next();
      return;
    }
    // 情况2：目标不是登录页
    if (!isAuthenticated) {
      // 未登录 → 强制跳转登录页
      next({ name: LOGIN_PAGE });
      return;
    }
    // 情况3：已登录，且不是去登录页 → 处理动态路由
    if (!dynamicRoutesAdded) {
      if (!lodash.isEmpty(menuList)) {
        const routeList = buildRouteData(menuList);
        routeList.forEach((route) => {
          router.addRoute(route);
        });
        dynamicRoutesAdded = true;
        next({ ...to, replace: true });
        return;
      }
    }
    // 默认放行
    next();
  } catch (error) {
    console.error('路由守卫异常:', error);
  }
});

router.afterEach((to, from, failure) => {
  if (failure) {
    return;
  }
  if (to.name === LOGIN_PAGE || to.name === HOME_PAGE) {
    return;
  }
  // 添加tag
  if (to.path !== '/') {
    const tagItem = lodash.cloneDeep(to);
    tagItem.formName = from.name;
    useSystemStore().addPageTag(tagItem);
  }
  // 添加KeepAlive
  if (to.meta.keepAlive) {
    useSystemStore().addKeepAliveName(to.name);
  }
});

export const closeCurrentPage = () => {
  const currentRoute = router.currentRoute.value;
  const routeName = currentRoute.name;
  useSystemStore().closePageAndPush(routeName, routeName);
};

function buildRouteData(menuList = [], rootParentId = 0) {
  const map = {};
  const result = [];
  for (const item of menuList) {
    item.name = item.path;
    item.meta = {
      title: item.menuName,
      icon: item.icon
    };
    // 目录
    if (item.menuType === MENU_TYPE_ENUM.DIRECTORY.value) {
      item.component = Layout;
    }
    // 菜单
    if (item.menuType === MENU_TYPE_ENUM.MENU.value) {
      item.meta.keepAlive = item.keepAliveFlag;
      item.meta.hideMenuFlag = item.hideMenuFlag;
      const componentPath = item.component.replace(/\.vue$/, '');
      item.component = () => import(`@/views/${componentPath}.vue`);
      item.component().then((val) => {
        val.default.name = item.name;
      });
    }
    map[item.menuId] = { ...item };
  }
  for (const item of menuList) {
    const node = map[item.menuId];
    if (item.parentId === rootParentId) {
      result.push(node);
    } else {
      const parent = map[item.parentId];
      if (parent) {
        if (parent.children) {
          parent.children.push(node);
        } else {
          parent.children = [node];
        }
      }
    }
  }
  return result;
}
